import { useSettings } from "@/hooks";
import { SellerNotifications } from "@/models";
import { showToast } from "@/utils";
import { Box, Flex, Stack, Text } from "@chakra-ui/react";
import { NotificationSwitch } from "./_NotificationSwitch";
import { Alert as AlertBarte } from "barte-design-system";
import { useState } from "react";
interface BankSlipProps {
  data: SellerNotifications;
}
const BankSlipConfig = ({ data }: BankSlipProps) => {
  const { patchActive } = useSettings();
  const [isDisable, setIsDisable] = useState<boolean>(data?.activeAllNotifications ? false : true);
  const handleSwitchChange = async (type: string, active: boolean) => {
    const switchValues = {
      type,
      active,
    };
    try {
      await patchActive(switchValues);
      showToast({
        message: active ? "Notificação ativada!" : "Notificação desativada!",
        type: "success",
      });
    } catch (error) {
      error?.response?.data?.errors.map((error) => {
        showToast({
          type: "error",
          message: `${error?.code} - ${error?.description}`
        })
      });
    }
  };

  return (
    <Flex flexDir="column" w="100%" justify="space-between">
      <Stack spacing="3rem" w="100%" justify="space-between">
        {isDisable && 
        <AlertBarte
          title="Suas notificações de cobrança estão desativadas"
          variant="warning"
          description="Para ativá-las, vá em Notificações -> Configurações Gerais"
          onClose={() => setIsDisable(false)}
          action={() => {}}
        />
        
        }
        <Text color="black" fontSize="2xl" fontWeight="bold">
          Pagamentos em boleto
        </Text>
        <Stack
          maxW="1100px"
          justify="space-between"
          direction="row"
          spacing="2rem"
        >
          <Box>
            <Flex flexDir="column">
              <Text color="black" fontWeight="bold" marginBottom="1rem">
                Notificações pré vencimento
              </Text>
              <Stack marginTop="1rem" spacing="1rem">
                <Flex h="70px" w="480px" justify="space-between">
                  <Text color="black">
                    Notificar{" "}
                    <Text display="inline" fontWeight="bold">
                      15
                    </Text>{" "}
                    dias antes do vencimento
                  </Text>
                  <NotificationSwitch
                    emailDefaultChecked={
                      data?.bankSlipPrePaymentWithFifteenDays
                    }
                    emailName="BANK_SLIP_PREPAYMENT_FIFTEEN_DAYS"
                    handleSwitch={handleSwitchChange}
                    whatsappDefaultChecked={
                      data?.bankSlipPrePaymentWithFifteenDaysWhatsApp
                    }
                    whatsappName="BANK_SLIP_PREPAYMENT_WHATSAPP_FIFTEEN_DAYS"
                    isDisable={isDisable}
                  />
                </Flex>
                <Flex h="70px" w="480px" justify="space-between">
                  <Text color="black">
                    Notificar{" "}
                    <Text display="inline" fontWeight="bold">
                      7
                    </Text>{" "}
                    dias antes do vencimento
                  </Text>
                  <NotificationSwitch
                    emailDefaultChecked={data?.bankSlipPrePaymentWithSevenDays}
                    emailName="BANK_SLIP_PREPAYMENT_SEVEN_DAYS"
                    handleSwitch={handleSwitchChange}
                    whatsappDefaultChecked={
                      data?.bankSlipPrePaymentWithSevenDaysWhatsApp
                    }
                    whatsappName="BANK_SLIP_PREPAYMENT_WHATSAPP_SEVEN_DAYS"
                    isDisable={isDisable}
                  />
                </Flex>
                <Flex h="70px" w="480px" justify="space-between">
                  <Text color="black">
                    Notificar{" "}
                    <Text display="inline" fontWeight="bold">
                      2
                    </Text>{" "}
                    dias antes do vencimento
                  </Text>
                  <NotificationSwitch
                    emailDefaultChecked={data?.bankSlipPrePaymentWithTwoDays}
                    emailName="BANK_SLIP_PREPAYMENT_TWO_DAYS"
                    handleSwitch={handleSwitchChange}
                    whatsappDefaultChecked={
                      data?.bankSlipPrePaymentWithTwoDaysWhatsApp
                    }
                    whatsappName="BANK_SLIP_PREPAYMENT_WHATSAPP_TWO_DAYS"
                    isDisable={isDisable}
                  />
                </Flex>
              </Stack>
            </Flex>
          </Box>
          <Box w="600px">
            <Flex flexDir="column">
              <Stack spacing=".8rem">
                <Text color="gray.400">Preview da mensagem</Text>
                <Flex p="1rem" bgColor="gray.25" borderRadius="3">
                  <Stack spacing=".8rem" color="black">
                    <Text
                      lineHeight="3rem"
                      dangerouslySetInnerHTML={{
                        __html: data?.bankSlipPrePaymentMessage?.replace(
                          /\n/gi,
                          "<br/>"
                        ),
                      }}
                    />
                  </Stack>
                </Flex>
                <Text fontSize=".8rem" color="gray.400">
                  *Enviaremos o link da fatura por email
                </Text>
              </Stack>
            </Flex>
          </Box>
        </Stack>
        <Stack
          maxW="1100px"
          justify="space-between"
          direction="row"
          spacing="2rem"
        >
          <Box>
            <Flex flexDir="column">
              <Text color="black" fontWeight="bold" marginBottom="1rem">
                Notificação de pagamento efetuado
              </Text>
              <Stack marginTop="1rem" spacing="1rem">
                <Flex h="70px" w="480px" justify="space-between">
                  <Text color="black">Ao confirmar pagamento</Text>
                  <NotificationSwitch
                    emailDefaultChecked={data?.bankSlipPayment}
                    emailName="BANK_SLIP_PAYMENT"
                    handleSwitch={handleSwitchChange}
                    whatsappDefaultChecked={data?.bankSlipPaymentWhatsApp}
                    whatsappName="BANK_SLIP_PAYMENT_WHATSAPP"
                    isDisable={isDisable}
                  />
                </Flex>
              </Stack>
            </Flex>
          </Box>
          <Box w="600px">
            <Flex flexDir="column">
              <Stack spacing=".8rem">
                <Text color="gray.400">Preview da mensagem</Text>
                <Flex p="1rem" bgColor="gray.25" borderRadius="3">
                  <Stack spacing=".8rem" color="black">
                    <Text
                      lineHeight="3rem"
                      dangerouslySetInnerHTML={{
                        __html: data?.bankSlipPaymentMessage?.replace(
                          /\n/gi,
                          "<br/>"
                        ),
                      }}
                    />
                  </Stack>
                </Flex>
              </Stack>
            </Flex>
          </Box>
        </Stack>

        <Stack
          maxW="1100px"
          justify="space-between"
          direction="row"
          spacing="2rem"
        >
          <Box>
            <Flex flexDir="column">
              <Text color="black" fontWeight="bold">
                Notificações pós vencimento
              </Text>
              <Text fontSize=".8rem" color="gray.400" w="350px">
                Notificações pós vencimento só serão enviadas em caso de não
                identificação do pagamento.
              </Text>
              <Stack marginTop="2rem" spacing="1rem">
                <Flex h="70px" w="480px" justify="space-between">
                  <Text color="black">
                    Notificar{" "}
                    <Text display="inline" fontWeight="bold">
                      2
                    </Text>{" "}
                    dias depois do vencimento
                  </Text>
                  <NotificationSwitch
                    emailDefaultChecked={data?.bankSlipLatePaymentWithTwoDays}
                    emailName="BANK_SLIP_LATE_PAYMENT_TWO_DAYS"
                    handleSwitch={handleSwitchChange}
                    whatsappDefaultChecked={
                      data?.bankSlipLatePaymentWithTwoDaysWhatsApp
                    }
                    whatsappName="BANK_SLIP_LATE_PAYMENT_WHATSAPP_TWO_DAYS"
                    isDisable={isDisable}
                  />
                </Flex>
                <Flex h="70px" w="480px" justify="space-between">
                  <Text color="black">
                    Notificar{" "}
                    <Text display="inline" fontWeight="bold">
                      7
                    </Text>{" "}
                    dias depois do vencimento
                  </Text>
                  <NotificationSwitch
                    emailDefaultChecked={data?.bankSlipLatePaymentWithSevenDays}
                    emailName="BANK_SLIP_LATE_PAYMENT_SEVEN_DAYS"
                    handleSwitch={handleSwitchChange}
                    whatsappDefaultChecked={
                      data?.bankSlipLatePaymentWithSevenDaysWhatsApp
                    }
                    whatsappName="BANK_SLIP_LATE_PAYMENT_WHATSAPP_SEVEN_DAYS"
                    isDisable={isDisable}
                  />
                </Flex>
                <Flex h="70px" w="480px" justify="space-between">
                  <Text color="black">
                    Notificar{" "}
                    <Text display="inline" fontWeight="bold">
                      20
                    </Text>{" "}
                    dias depois do vencimento
                  </Text>
                  <NotificationSwitch
                    emailDefaultChecked={
                      data?.bankSlipLatePaymentWithTwentyDays
                    }
                    emailName="BANK_SLIP_LATE_PAYMENT_TWENTY_DAYS"
                    handleSwitch={handleSwitchChange}
                    whatsappDefaultChecked={
                      data?.bankSlipLatePaymentWithTwentyDaysWhatsApp
                    }
                    whatsappName="BANK_SLIP_LATE_PAYMENT_WHATSAPP_TWENTY_DAYS"
                    isDisable={isDisable}
                  />
                </Flex>
              </Stack>
            </Flex>
          </Box>
          <Box w="600px">
            <Flex flexDir="column">
              <Stack spacing=".8rem">
                <Text color="gray.400">Preview da mensagem</Text>
                <Flex p="1rem" bgColor="gray.25" borderRadius="3">
                  <Stack spacing=".8rem" color="black">
                    <Text
                      lineHeight="3rem"
                      dangerouslySetInnerHTML={{
                        __html: data?.bankSlipLatePaymentMessage?.replace(
                          /\n/gi,
                          "<br/>"
                        ),
                      }}
                    />
                  </Stack>
                </Flex>
                <Text fontSize=".8rem" color="gray.400">
                  *Enviaremos o link da fatura por email
                </Text>
              </Stack>
            </Flex>
          </Box>
        </Stack>
      </Stack>
    </Flex>
  );
};

export { BankSlipConfig };
